/**
 * Notification Preferences API Endpoints
 * Manage user notification and engagement preferences
 */

import apiClient from '../client';

export interface NotificationChannels {
  in_app: boolean;
  push: boolean;
  email: boolean;
}

export interface NotificationPreferences {
  weekly_checkin_enabled: boolean;
  weekly_checkin_day: string;
  weekly_checkin_time: string;
  inactivity_nudge_enabled: boolean;
  inactivity_threshold_days: number;
  education_content_enabled: boolean;
  notification_channels: NotificationChannels;
  timezone: string;
}

export interface NotificationPreferencesResponse {
  preferences: NotificationPreferences;
}

export const notificationPreferencesApi = {
  /**
   * GET /notification_preferences
   * Get current notification preferences
   */
  getPreferences: async (): Promise<NotificationPreferencesResponse> => {
    const response = await apiClient.get<NotificationPreferencesResponse>('/notification_preferences');
    return response.data;
  },

  /**
   * PUT /notification_preferences
   * Update notification preferences (partial merge)
   */
  updatePreferences: async (
    prefs: Partial<Omit<NotificationPreferences, 'notification_channels'>> & {
      notification_channels?: Partial<NotificationChannels>;
    }
  ): Promise<NotificationPreferencesResponse> => {
    const response = await apiClient.put<NotificationPreferencesResponse>(
      '/notification_preferences',
      prefs
    );
    return response.data;
  },
};
